let slide_template_customDev_slide = document.querySelectorAll('.slide_template_customDev_slide');
let ChaimMainCOwekldjf = document.querySelector('.CharmMainCOntainer');
let popup_email = document.querySelector('.popup_email');

function waitForImagesLoaded(node) {
  var imgs = Array.from(node.querySelectorAll("img"));
  return Promise.all(
    imgs.map(function (img) {
      if (img.complete && img.naturalWidth !== 0) {
        return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
      }
      return new Promise(function (resolve) {
        img.addEventListener("load", resolve, { once: true });
        img.addEventListener("error", resolve, { once: true });
      }).then(function () {
        return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
      });
    }),
  );
}

function waitForNodeReady(node) {
  var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
  return Promise.all([fontsReady, waitForImagesLoaded(node)]);
}

var preload_entities = {
    "screen_size": document.querySelector('.charm-container').offsetWidth,
    "chain": {},
    "charms": {},
    "number_of_charms": 0,
    "expiry": 'true'
};

function CharmSlide(e) {
    document.querySelector('.xcmvsdklfjcnvx').style.opacity = '1'
    slide_template_customDev_slide[0].classList.replace('active', 'previous');
    slide_template_customDev_slide[1].classList.replace('next', 'active');
}

function ChainSlide() {
    slide_template_customDev_slide[1].classList.replace('active', 'next');
    slide_template_customDev_slide[0].classList.replace('previous', 'active');
}

function TotalCart() {
    let cartTotal = 0
    let allTotal = document.querySelectorAll('.productCartContainerGrid');
    let Total = document.querySelector('.gridtablecarttotal .rightAlign');
    jQuery('.toolTipdragandDropasdfkjdsfk.show').removeClass('show');
    jQuery('.toolTipdragandDrop.show').removeClass('show');
    jQuery('.charm_w [class*="charm-"]').css('opacity', 0);
    allTotal.forEach(div => {
        let itemTotal = div.getAttribute('data-price');
        cartTotal = cartTotal + parseFloat(itemTotal);
    })
    Total.innerHTML = '$' + cartTotal
    slide_template_customDev_slide[1].classList.replace('active', 'previous');
    slide_template_customDev_slide[2].classList.replace('next', 'active');
}

function CharmSlideAgain() {
    slide_template_customDev_slide[2].classList.replace('active', 'next');
    slide_template_customDev_slide[1].classList.replace('previous', 'active');
    jQuery('.charm_w [class*="charm-"]').css('opacity', 1);
}
let attachment_style_tootltipSVG = document.querySelectorAll('.attachment_style_tootltipSVG');
let attachment_style_tootltiptoolTipdragandDrop = document.querySelectorAll('.attachment_style_tootltip .toolTipdragandDrop');
let styleOverlay = document.querySelectorAll('.attachment_style_tootltip .styleOverlay');
attachment_style_tootltipSVG.forEach((svg, index) => {
    svg.addEventListener('click', () => {
        attachment_style_tootltiptoolTipdragandDrop[index].classList.add('show');
        styleOverlay[index].style.display = 'block';
    })
})

function CancelPopupToolTT() {
    jQuery('.attachment_style_tootltip  .toolTipdragandDrop').removeClass('show')
    jQuery('.attachment_style_tootltip  .styleOverlay').css('display', 'none');
}

function CancelPopup() {
    document.querySelector('.charm_builder  .toolTipdragandDrop').classList.remove('show')
}

function CancelPopupSave() {
    document.querySelector('.popup_email').style.display = 'none';
}

function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function postCharmsImg(base64 = "", selectCharm, index, length, side_engraving, customData, saved) {
    var image = base64;
    var block = image.split(";");
    var contentType = block[0].split(":")[1]; // In this case "image/gif"
    var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
    var blob = b64toBlob(realData, contentType);
    var formDataToUpload = new FormData();
    formDataToUpload.append("image", blob);
    $.ajax({
        // url:"http://localhost:8888/test.php",
        url: "https://harthagertyjewelry.com",
        data: formDataToUpload, // Add as Data the Previously create formData
        type: "POST",
        contentType: false,
        processData: false,
        cache: false,
        dataType: "json", // Change this according to your response from the server.
        error: function(err) {
            console.log(err);
        },
        success: function(data) {
            if (selectCharm) {
                if (index == 0) {
                    // jQuery(selectCharm).attr('data-drag-able-image', data.url)
                    if (side_engraving == 'double') {
                        customData[`Front_Image`] = data.url;
                        jQuery(selectCharm).attr('data-front-side-image', image)
                    } else {
                        customData[`${capitalize(side_engraving)}_Image`] = data.url;
                        jQuery(selectCharm).attr(`data-${side_engraving}-side-image`, image)
                    }
                } else {
                    customData[`Back_Image`] = data.url;
                    jQuery(selectCharm).attr('data-back-side-image', image)
                }
                if (length == index + 1) {
                    document.querySelector('.loading_screen').style.display = 'none';
                    let parentMain = document.querySelector('.engraving_contwerakfjsadlkfjwoeifjsmdnv.show.preview');
                    parentMain.classList.remove('preview')
                    parentMain.classList.remove('show')
                    jQuery(selectCharm).trigger('click', customData);
                }
            } else {
                if (saved == true) {
                    document.querySelector('.loading_gif_save_feature').style.display = 'none';
                    document.querySelector('.success_charm_image').style.display = 'block';
                    document.querySelector('.success_charm_image img#savedDesignPreview').src = data.url;
                    let design_data = Date.now();
                    let search_params = window.location.search.replace('?', '').split('&');
                    let tags = [`currentDesign_${data.url}`]; // unique design ID
                    for (let index = 0; index < search_params.length; index++) {
                        if (search_params[index].startsWith('charms')) {
                            let charms_param = JSON.parse(decodeURIComponent(search_params[index].split('=')[1]));
                            for (let [index, charm] of Object.entries(charms_param)) {
                                let query_charm = new URLSearchParams(JSON.stringify(charm))
                                tags.push('charm_' + index + '_' + query_charm.toString());
                            }
                        } else {
                            tags.push(search_params[index]);
                        }
                    }
                    document.getElementById("customerTagsInput").value = tags.join(",");
                } else {
                    // debugger
                    jQuery('#custom_charm_image_id').val(data.id);
                    jQuery('#custom_charm_image').val(data.url);
                    Shopify.moveAlong();
                }

            }
        },
        complete: function() {
            console.log("Request finished.");
        }
    });
}

function SendingEventToKlaviyo() {
    document.querySelector('.loading_gif_save_feature').style.display = 'flex';
    document.querySelector('.success_charm_image').style.display = 'none';
}

function SaveFeature(e) {
    CancelPopup();
    jQuery('.toolTipdragandDropasdfkjdsfk.show').removeClass('show');
    jQuery('.toolTipdragandDrop.show').removeClass('show');
    jQuery('.charm_w [class*="charm-"]').css('opacity', 0);
    let params = new URLSearchParams(window.location.search);
    // let settings = JSON.parse(params.get("settings"));
    popup_email.style.display = 'flex';

    var nodeSaved = document.querySelector('#image_visual #charm_visual');
    waitForNodeReady(nodeSaved).then(function () {
        return domtoimage.toPng(nodeSaved); // warm-up pass, same size, result discarded
    }).then(function () {
        return domtoimage.toPng(nodeSaved); // real pass
    }).then(function (dataUrl) {
        postCharmsImg(dataUrl, selectCharm = null, index = null, length = null, side_engraving = null, customData = null, saved = true);
    }).catch(function (e) {
        console.log(e);
    });
    
    // domtoimage.toPng(nodeSaved,
    // {
    //     width: 100,
    //     height: 100
    // })
    // .then(function (dataUrl) {
    //     domtoimage.toPng(nodeSaved)
    //         .then(function (dataUrl) {
    //             var img = new Image();
    //             img.src = dataUrl;
    //             var img_src = img.src;
    //             postCharmsImg(dataUrl, selectCharm = null, index = null, length = null, side_engraving = null, customData = null, saved = true);
    //         });
    // }).catch(e => {
    //     console.log(e);
    // });
}

function getStyleSheet() {
    for (var i = 0; i < document.styleSheets.length; i++) {
        var sheet = document.styleSheets[i];
        if (sheet.href !== null) {
            sheet.ownerNode.crossorigin = "anonymous";
            sheet.ownerNode.setAttribute("crossorigin", "anonymous");
        }

    }
}
var charmsData = collections.charms.reduce(function(accum, product, i) {
    accum[product.id] = product;
    var variantHash = product.variants.reduce(function(accumv, variant, j) {
        accumv[variant.id] = variant;
        return accumv;
    }, {});
    accum[product.id].variants = variantHash;
    return accum;
}, {});
var chainsData = collections.chains.reduce(function(accum, product, i) {
    accum[product.id] = product;
    var variantHash = product.variants.reduce(function(accumv, variant, j) {
        accumv[variant.id] = variant;
        return accumv;
    }, {});
    accum[product.id].variants = variantHash;
    return accum;
}, {});

function getRotationDegrees($el) {
    let matrix = $el.css("-webkit-transform") ||
        $el.css("-moz-transform") ||
        $el.css("-ms-transform") ||
        $el.css("-o-transform") ||
        $el.css("transform");
    let angle = 0;
    if (matrix !== 'none') {
        let values = matrix.split('(')[1].split(')')[0].split(',');
        let a = values[0];
        let b = values[1];
        angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
    }
    return (angle);
}


function rotate($el, degrees) {
    $el.css({
        '-webkit-transform': 'rotate(' + degrees + 'deg)',
        '-moz-transform': 'rotate(' + degrees + 'deg)',
        '-ms-transform': 'rotate(' + degrees + 'deg)',
        '-o-transform': 'rotate(' + degrees + 'deg)',
        'transform': 'rotate(' + degrees + 'deg)',
        'zoom': 1

    });
}

function capitalizeFirstLetter(val) {
    val = String(val).toLowerCase(); // convert all to lowercase first
    return val.charAt(0).toUpperCase() + val.slice(1);
}

function getPosTop(index) {
    var top = $('.charm[data-index="1"]').position().top; //70% from top of container
    var topOffset = 3; //calculate this dynamically down the road?
    if (index == 2 || index == 3)
        return (top - topOffset);
    else if (index == 4 || index == 5)
        return (top - 1.5 * topOffset);
    else if (index == 6 || index == 7)
        return (top - 2 * topOffset - 3);
    else if (index == 8 || index == 9)
        return (top - 2.5 * topOffset - 9);
}

function getPosLeft(index) {
    var left = $('.charm[data-index="1"]').position().left; //48% from left of container
    var leftOffset = 1; // calculate this dynamically down the road?
    if (index == 2)
        return (left - leftOffset);
    else if (index == 3)
        return (left + leftOffset);
    else if (index == 4)
        return (left - 2 * leftOffset);
    else if (index == 5)
        return (left + 2 * leftOffset);
    else if (index == 6)
        return (left - 3 * leftOffset - 5);
    else if (index == 7)
        return (left + 3 * leftOffset + 5);
    else if (index == 8)
        return (left - 4 * leftOffset - 11);
    else if (index == 9)
        return (left + 3 * leftOffset + 11);
}

function touchHandler(event) {
    var touch = event.changedTouches[0];

    var simulatedEvent = document.createEvent("MouseEvent");
    simulatedEvent.initMouseEvent({
            touchstart: "mousedown",
            touchmove: "mousemove",
            touchend: "mouseup"
        }[event.type], true, true, window, 1,
        touch.screenX, touch.screenY,
        touch.clientX, touch.clientY, false,
        false, false, false, 0, null);

    touch.target.dispatchEvent(simulatedEvent);
    //event.preventDefault();
}

function init_touchevents() {
    document.addEventListener("touchstart", touchHandler, true);
    document.addEventListener("touchmove", touchHandler, true);
    document.addEventListener("touchend", touchHandler, true);
    document.addEventListener("touchcancel", touchHandler, true);
}

var prevPos = null,
    diffX, diffY, maxDiff;

function EngraveText(element) {
    const text = element.value;
    const isAllUppercase = text !== '' && text === text.toUpperCase();
    const isOnlyNumbersAndSpecials = /^[0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~ ]+$/.test(text);
    if (!element.getAttribute('name').includes('Monogram') && !isOnlyNumbersAndSpecials && isAllUppercase) {
        element.parentElement.parentElement.querySelector('.attachment_style_tootltip .styleOverlay').style.display = 'block';
        element.parentElement.parentElement.querySelector('.attachment_style_tootltip .toolTipdragandDrop').classList.add('show');
        element.value = capitalizeFirstLetter(text);
    }
    let engrave_field = document.querySelector(`.engrave_text_on_image[data-product-id="${element.dataset.productId}"][data-lineId="${element.id}"]`);
    if (element.getAttribute('data-engrave-option').includes('monogram')) {
        if (element.value.length == 1) {
            engrave_field.innerHTML = `<span class="bigger">${element.value[0]}</span>`;
            engrave_field.classList.remove("grid_columns");
        } else if (element.value.length == 3) {
            engrave_field.innerHTML = `${element.value[0]}<span class="bigger">${element.value[1]}</span>${element.value[2]}`;
            engrave_field.classList.add('grid_columns');
        } else {
            engrave_field.classList.remove('grid_columns');
            engrave_field.innerHTML = element.value;
        }
    } else {
        engrave_field.innerHTML = element.value;
        // Reset transform to calculate actual width
        engrave_field.style.transform = "scale(1)";

        let wrapperWidth = engrave_field.parentElement.parentElement.offsetWidth;
        let textWidth = engrave_field.scrollWidth;

        if (textWidth > wrapperWidth) {
            let scale = wrapperWidth / textWidth;
            engrave_field.style.transform = `scale(${scale})`;
        }
    }
}

function ChangeFont(element) {
    let inputFields = document.querySelectorAll(`.engrave_${element.dataset.optionType}[data-product-id="${element.dataset.productId}"] .engrave_text_on_image`);
    element.style.fontFamily = `'${element.value}'`;
    inputFields.forEach(text => {
        // document.querySelector(`#${text.dataset.lineid}`).value = '';
        // text.innerHTML = '';
        text.style.fontFamily = `'${element.value}'`;
    })
}

function OpenPreview(element) {
    let productId = element.getAttribute('data-product-id');
    let engraving_product_content = document.querySelector(`.engraving_contwerakfjsadlkfjwoeifjsmdnv[data-product-id="${productId}"]`);
    document.querySelector(`.product-tooltip[data-product-id="${productId}"] .product-info`).style.display = 'none';
    document.querySelector(`.product-tooltip[data-product-id="${productId}"] .product_charm_header`).style.display = 'none';
    engraving_product_content.classList.add('preview');
}

function ClosePreview(element) {
    let productId = element.getAttribute('data-product-id');
    document.querySelector(`.engraving_contwerakfjsadlkfjwoeifjsmdnv[data-product-id="${productId}"]`).classList.remove('preview');
    document.querySelector(`.product-tooltip[data-product-id="${productId}"] .product-info`).style.display = 'block';
    document.querySelector(`.product-tooltip[data-product-id="${productId}"] .product_charm_header`).style.display = 'grid';
}

function RotateSide(element, front, back) {
    if (element.dataset.side == 'front') {
        element.setAttribute('data-side', 'back');
        element.nextElementSibling.src = back;
    } else {
        element.setAttribute('data-side', 'front');
        element.nextElementSibling.src = front;
    }
}

function EnableAddToCart(element) {
    if (element.checked == true) {
        jQuery(element).parents('.lmxcnweirusdkjf').find('.add_to_cart_button').attr('data-disabled', false)
        jQuery(element).parents('.lmxcnweirusdkjf').find('.add_to_cart_button').removeAttr('disabled')
    } else {
        jQuery(element).parents('.lmxcnweirusdkjf').find('.add_to_cart_button').attr('data-disabled', true)
        jQuery(element).parents('.lmxcnweirusdkjf').find('.add_to_cart_button').attr('disabled', true)
    }
}

function SelectCharmBtn(element) {
    document.querySelector('.loading_screen').style.display = 'flex';
    document.querySelector('.loading_screen .main_loading_grid_container').style.display = 'none';
    let productId = element.getAttribute('data-product-id');
    let selectItemBtn = document.querySelector(`._visual_charms_[data-selected-pid="${productId}"]`)
    let engraving_product_content = document.querySelector(`.engraving_contwerakfjsadlkfjwoeifjsmdnv[data-product-id="${productId}"]`);
    document.querySelector(`.product-tooltip[data-product-id="${productId}"] .product-info`).style.display = 'block';
    document.querySelector(`.product-tooltip[data-product-id="${productId}"] .product_charm_header`).style.display = 'grid';
    let side_engraving = engraving_product_content.dataset.sideEngraving
    let nodes = [];
    let properties = {};
    let propertiesContainer;
    switch (side_engraving) {
        case 'front':
            nodes.push(engraving_product_content.querySelector('.engrave_side_content[data-side="front"]'));
            propertiesContainer = Array.from(engraving_product_content.querySelector('.engrave_side_content[data-side="front"] .engrave_content').children).filter(child => child.getAttribute('data-selected') == 'true')[0];
            if (propertiesContainer.dataset.type == 'Text') {
                properties['Front_Engrave'] = 'Text';
                propertiesContainer.querySelectorAll('span').forEach((span, index) => {
                    properties['Text_Line_' + index] = span.innerText;
                })
                properties['Text_Font_Family'] = propertiesContainer.children[0].style.fontFamily;
            } else {
                properties['Front_Engrave'] = 'Monogram';
                properties['Monogram_Content'] = propertiesContainer.textContent.trim();
                if (propertiesContainer.children[0].style.fontFamily.includes('Cursive Engraving')) {
                    properties['Monogram_Font_Family'] = 'Garden Gate Font';
                } else {
                    properties['Monogram_Font_Family'] = 'Bamboo Font';
                }
            }
            break;
        case 'back':
            nodes.push(engraving_product_content.querySelector('.engrave_side_content[data-side="back"]'));
            propertiesContainer = Array.from(engraving_product_content.querySelector('.engrave_side_content[data-side="back"] .engrave_content').children).filter(child => child.getAttribute('data-selected') == 'true')[0];
            if (propertiesContainer.dataset.type == 'Text') {
                properties['Back_Engrave'] = 'Text';
                propertiesContainer.querySelectorAll('span').forEach((span, index) => {
                    properties['Text_Line_' + index] = span.innerText;
                })
                properties['Text_Font_Family'] = propertiesContainer.children[0].style.fontFamily;
            } else {
                properties['Back_Engrave'] = 'Monogram';
                properties['Monogram_Content'] = propertiesContainer.textContent.trim();
                if (propertiesContainer.children[0].style.fontFamily.includes('Cursive Engraving')) {
                    properties['Monogram_Font_Family'] = 'Garden Gate Font';
                } else {
                    properties['Monogram_Font_Family'] = 'Bamboo Font';
                }
            }
            break;
        case 'double':
            engraving_product_content.querySelectorAll('.engrave_side_content[data-side="back"] , .engrave_side_content[data-side="front"]').forEach(side => {
                nodes.push(side);
                propertiesContainer = Array.from(side.querySelector('.engrave_content').children).filter(child => child.getAttribute('data-selected') == 'true')[0];
                if (propertiesContainer.dataset.type == 'Text') {
                    properties[`${capitalize(side.dataset.side)}_Engrave`] = 'Text';
                    propertiesContainer.querySelectorAll('span').forEach((span, index) => {
                        properties[capitalize(side.dataset.side) + 'Text_Line_' + index] = span.innerText;
                    })
                    properties[capitalize(side.dataset.side) + 'Text_Font_Family'] = propertiesContainer.children[0].style.fontFamily;
                } else {
                    properties[`${capitalize(side.dataset.side)}_Engrave`] = 'Monogram';
                    properties[capitalize(side.dataset.side) + 'Monogram_Content'] = propertiesContainer.textContent.trim();
                    if (propertiesContainer.children[0].style.fontFamily.includes('Cursive Engraving')) {
                        properties[capitalize(side.dataset.side) + 'Monogram_Font_Family'] = 'Garden Gate Font';
                    } else {
                        properties[capitalize(side.dataset.side) + 'Monogram_Font_Family'] = 'Bamboo Font';
                    }
                }
            })
            break;
    }
    Promise.all(Array.from(nodes).map((node) => domtoimage.toPng(node)))
        .then((dataUrls) => {
            dataUrls.forEach((dataUrl, index) => {
                postCharmsImg(dataUrl, selectItemBtn, index, dataUrls.length, side_engraving, properties);
            });
        })
        .catch((e) => {
            console.log(e);
        });
}

let loadingScreen = document.querySelector('.loading_screen');
let Product__Wrapper = document.querySelector('.Product__Wrapper');

// Check if saved builder is older than 1 week
function isBuilderExpired(params) {
    const lastUpdated = localStorage.getItem("last_updated");
    if (params.get('expiry') == 'false') return false; // never expire
    if (!lastUpdated) return false; // no data saved yet
    const lastTime = new Date(lastUpdated).getTime();
    const now = Date.now();
    const oneWeekMs = 7 * 24 * 60 * 60 * 1000;
    // const oneWeekMs = 5 * 60 * 1000;
    return (now - lastTime) > oneWeekMs;
}

function urlCheck() {
    // Retrieve full object from URL
    let params = window.location.search ? new URLSearchParams(window.location.search) : localStorage.getItem("queryString") ? new URLSearchParams(JSON.parse(localStorage.getItem("queryString"))) : new URLSearchParams(); 

    if (isBuilderExpired(params)) {
        window.history.replaceState({}, document.title, window.location.pathname);
        localStorage.removeItem("queryString");
        localStorage.removeItem("last_updated");
        loadingScreen.style.display = 'none';
        Product__Wrapper.style.display = 'grid';
    } else {
        if (params.size !== 0) {
            if(params.get('expiry') == 'false') {
                document.querySelector('.loading_screen .main_loading_grid_container').style.display = 'none';
                LoadPreviousFunction();
            } else {
                if (params.get('customer_posted') == 'true') {
                    document.querySelector('.loading_screen .Alert--success').style.display = 'block';
                }
                document.querySelector('.loading_screen .previous_charm_text').style.display = 'block';
                document.querySelector('.loading_screen .main_loading_grid_container').style.display = 'none';
                document.querySelector('.loading_screen .loading_gif').style.display = 'none';
                loadingScreen.style.cursor = 'auto';
                // document.querySelector('.loading_screen .add_to_cart_text').style.display = 'block';
            }
        } else {
            loadingScreen.style.display = 'none';
            Product__Wrapper.style.display = 'grid';
        }
    }

}

function scalePointPosition(originalTop, originalLeft, originalWidth, originalHeight, newWidth, newHeight) {
  const topRatio = originalTop / originalHeight;
  const leftRatio = originalLeft / originalWidth;

  const newTop = newHeight * topRatio;
  const newLeft = newWidth * leftRatio;

  return { top: newTop, left: newLeft };
}

function StartOverFunction() {
    document.querySelector('.loading_screen .Alert--success').style.display = 'none';
    window.history.replaceState({}, document.title, window.location.pathname);
    localStorage.removeItem("queryString");
    document.querySelector('.previous_charm_text').style.display = 'none';
    loadingScreen.style.display = 'none';
    Product__Wrapper.style.display = 'grid';
}

function LoadPreviousFunction() {
    document.querySelector('.loading_screen .Alert--success').style.display = 'none';
    document.querySelector('.previous_charm_text').style.display = 'none';
    document.querySelector('.loading_previous_desing').style.display = 'block';
    document.querySelector('.loading_screen .loading_gif').style.display = 'flex';
    let params = window.location.search ? new URLSearchParams(window.location.search) : localStorage.getItem("queryString") ? new URLSearchParams(JSON.parse(localStorage.getItem("queryString"))) : new URLSearchParams(); 
    if (params.get('customer_posted') == 'true') {
        params = new URLSearchParams(JSON.parse(localStorage.getItem("queryString")));
    }
    if (params.get('chain')) {
        let chain_settings = JSON.parse(params.get('chain'));
        let chainButton = document.querySelector(`.add-chain.btn._neclace_br_[data-selected-pid="${chain_settings.id}"]`);
        let previousChainOption = document.querySelector(`#id-${chain_settings.id}`);
        previousChainOption.value = chain_settings.variant;
        chainButton.click();
    }
    if (params.get('charms')) {
        let charms_settings = JSON.parse(params.get('charms'));
        let currentScreen = parseFloat(params.get('screen_size'));
        let params_screen_size = parseFloat(preload_entities.screen_size);
        for (let [id, charm] of Object.entries(charms_settings)) {
            const original = { top: charm.top.split('p')[0], left: charm.left.split('p')[0], width: params_screen_size, height: params_screen_size };
            const newSize = { width: currentScreen, height: currentScreen };
            const newPoint = scalePointPosition(
                original.top,
                original.left,
                original.width,
                original.height,
                newSize.width,
                newSize.height
            );
            // { top: 306.67, left: 186 }
            let charmButton = document.querySelector(`._visual_charms_[data-product-id="${charm.id}"]`);
                if (charmButton.classList.contains('singleVariant')) {
                    charmButton.click();
                    let charm_container = document.querySelector(`.charm_w.draggable[data-product-id="${charm.id}"][data-index="${parseInt(id) - 1}"]`);
                    charm_container.style.left = charm.left;
                    charm_container.style.top = charm.top;
                    rotate(jQuery(charm_container), charm.transform);
                }
        }
    }
    setTimeout(function() {
        document.querySelector('.loading_previous_desing').style.display = 'none';
        loadingScreen.style.cursor = 'wait';
        loadingScreen.style.display = 'none';
        Product__Wrapper.style.display = 'grid';
    }, 2000 );
}

function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
}

window.addEventListener("load", function() {
            getStyleSheet();
            var head = document.getElementsByTagName('head')[0];

            var script__1 = document.createElement('script');
            script__1.type = 'text/javascript';
            script__1.src = 'https://code.jquery.com/jquery-1.12.4.js';

            var script__2 = document.createElement('script');
            script__2.type = 'text/javascript';

            var script__3 = document.createElement('script');
            script__3.type = 'text/javascript';
            script__3.src = "https://cdnjs.cloudflare.com/ajax/libs/jqueryui-touch-punch/0.2.3/jquery.ui.touch-punch.min.js";

            script__2.onload = function() {
                    jQuery(document).on('touchstart', '.charm_w', function(e) {
                        $(this).addClass('hover_active');
                    });

                    jQuery(document).on('touchend', '.charm_w', function(e) {
                        $(this).addClass('hover_active');
                    });

                    jQuery(document).on('touchmove', '.charm_w', function(e) {
                        jQuery('.hover_active').toggleClass('hover_active');
                        $(this).addClass('hover_active');
                    });
                    let chainConditions = {
                        8967060455719: {
                            limit: 7,
                            content: 'Mini Belcher: '
                        }
                    }
                    setTimeout(function() {
                        jQuery(document).on('click', '.overSelectLabel', function(e) {
                            let productWrapperCurrentWidth = document.querySelector('.Product__Info');
                            let multiVariantProductToolTip = document.querySelectorAll('.product-tooltip.multiVariantToolTip');
                            let engraving_contwerakfjsadlkfjwoeifjsmdnv = document.querySelectorAll('.engraving_contwerakfjsadlkfjwoeifjsmdnv');
                            multiVariantProductToolTip.forEach((container) => {
                                container.style.maxWidth = productWrapperCurrentWidth.clientWidth + 'px';
                            })
                            engraving_contwerakfjsadlkfjwoeifjsmdnv.forEach((container) => {
                                container.style.maxWidth = `calc(100vw - ${productWrapperCurrentWidth.clientWidth}px)`;
                            })
                            let currentProductId = parseInt(jQuery(this).attr('data-product-id'))
                            let currentProductContainer = document.querySelector(`.product-tooltip.multiVariantToolTip[data-product-id="${currentProductId}"]`);
                            if (currentProductContainer.dataset.engraving == 'true') {
                                currentProductContainer.querySelector('.product-info > ul.lmxcnweirusdkjf > .selector-wrapper > .sw > label').click();
                            }
                            if (jQuery(this).attr('data-size-guide') == 'dev-custom-necklace') {
                                jQuery('.chainSizing').addClass('show')
                            }
                            currentProductContainer.style.transform = 'translateX(0)';
                        });
                        jQuery(document).on('click', '.product_charm_header a.back', function(e) {
                            if (jQuery('.chainSizing').hasClass('show')) {
                                jQuery('.chainSizing').removeClass('show')
                            }
                            if (document.querySelector('.product-tooltip.multiVariantToolTip.show[data-engraving="true"]')) {
                                let mainEngraving = document.querySelector('.product-tooltip.multiVariantToolTip.show[data-engraving="true"]');
                                mainEngraving.querySelector('.product-info').style.display = 'block';
                                mainEngraving.querySelector('.product-info > ul.lmxcnweirusdkjf > .selector-wrapper > .sw > label').click();
                            }
                            jQuery(this).parents('.product-tooltip').css('transform', 'translateX(100%)');
                        })
                        document.querySelectorAll('input[name="__tab-btn[]"]').forEach((radio) => {
                            radio.addEventListener('change', (event) => {
                                let content = document.querySelectorAll(`.ProductList.step1`);
                                content.forEach(grid => {
                                    grid.style.display = 'none';
                                });
                                document.querySelector(`#content_${radio.id}`).style.display = 'grid';
                            });
                        });
                        document.querySelectorAll('input[name="tab-btn-two[]"]').forEach((radio) => {
                            radio.addEventListener('change', (event) => {
                                let content = document.querySelectorAll(`.Collapsible__Content.sorting_filteration`);
                                content.forEach(grid => {
                                    grid.style.display = 'none';
                                });
                                document.querySelector(`.Collapsible__Content.sorting_filteration[data-sort="${radio.id}"]`).style.display = 'block';
                            });
                        });
                        document.querySelectorAll('input[name="intension_tab-btn[]"]').forEach((radio) => {
                            radio.addEventListener('change', (event) => {
                                let content = document.querySelectorAll(`.ProductList[data-sort="intension"]`);
                                content.forEach(grid => {
                                    grid.style.display = 'none';
                                });
                                document.querySelector(`#content_${radio.id}`).style.display = 'grid';
                            });
                        });
                        document.querySelectorAll('input[name="shop_by_size__tab-btn[]"]').forEach((radio) => {
                            radio.addEventListener('change', (event) => {
                                let content = document.querySelectorAll(`.ProductList[data-sort="shop_by_size"]`);
                                content.forEach(grid => {
                                    grid.style.display = 'none';
                                });
                                document.querySelector(`#content_${radio.id}`).style.display = 'grid';
                            });
                        });
                        document.querySelectorAll('input[name="shop_by_size__tab-btn_small[]"]').forEach((radio) => {
                            radio.addEventListener('change', (event) => {
                                let content = document.querySelectorAll(`.ProductList[data-sort="shop_by_size_small"]`);
                                content.forEach(grid => {
                                    grid.style.display = 'none';
                                });
                                document.querySelector(`#content_${radio.id}`).style.display = 'grid';
                            });
                        });
                        jQuery(document).on('click', '.ProductItem__Wrapper, .ProductItem .prod-title', function() {
                            if (jQuery(this).parent('.ProductItem').find('.overSelectLabel').length !== 0) {
                                jQuery(this).parent('.ProductItem').find('.overSelectLabel').click();
                            } else if (jQuery(this).parent('.ProductItem').find('.singleVaraintProduct').length !== 0) {
                                jQuery(this).parent('.ProductItem').find('.singleVaraintProduct .singleVariant.add-chain').click();
                            }
                        });
                        // const video = document.querySelector("video.main-image");
                        // video.muted = true; // Ensure muted
                        // video.play().catch(error => {
                        //   console.error("Autoplay failed:", error);
                        // });
                        urlCheck();
                        let lastScrollTop = 0; // Track the last scroll position
                    }, 2000);

                    jQuery('.single-option-selector').on('change', function() {
                        let selectedOption = parseInt(jQuery(this).attr('data-option'));
                        let productId = jQuery(this).attr('data-product-id');
                        let value = jQuery(this).val();
                        let otherOptionValue = '';
                        if (selectedOption == 0) {
                            otherOptionValue = jQuery('.single-option-selector[data-product-id="' + productId + '"][data-option="1"]:checked').val() || '';
                            value = value + '|' + otherOptionValue;
                        } else {
                            otherOptionValue = jQuery('.single-option-selector[data-product-id="' + productId + '"][data-option="0"]:checked').val();
                            value = otherOptionValue + '|' + value;
                        }
                        if (jQuery(this).attr('name').indexOf('Engrav') >= 0) {
                            let maxWidth = document.querySelector('.engraving_contwerakfjsadlkfjwoeifjsmdnv').style.maxWidth.split('(-')[1].split('px')[0];
                            if (jQuery(this).val() != 'Charm Without Engraving') {
                                jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv[data-product-id='${productId.split('-')[1]}']`).addClass('show');
                                jQuery(this).parents('.product-tooltip.multiVariantToolTip[data-engraving="true"][data-product-id="' + productId.split('-')[1] + '"]').addClass('show');
                                jQuery(this).parents('.product-info').find(`.add-chain.btn._visual_charms_[data-selected-pid="${productId.split('-')[1]}"]`).css('display', 'none');
                                jQuery(this).parents('.product-info').find(`.engraving_LastBtn.engraving_toolBtn[data-product-id="${productId.split('-')[1]}"]`).css('display', 'block');
                                jQuery(this).parents('.product-tooltip.multiVariantToolTip[data-engraving="true"][data-product-id="' + productId.split('-')[1] + '"]').css('grid-template-columns', `1fr ${maxWidth}px`);
                                jQuery(this).parents('.selector-wrapper').find('.side_engraving').css('display', 'block');

                                if (jQuery(this).val() == 'Front Side') {
                                    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv[data-product-id='${productId.split('-')[1]}']`).attr('data-side-engraving', 'front');
                                    jQuery(this).parents('.selector-wrapper').find('.side_engraving > .front_side_engraving').css('display', 'block');
                                    jQuery(this).parents('.selector-wrapper').find('.side_engraving > .back_side_engraving').css('display', 'none');
                                    jQuery(this).parents('.selector-wrapper').find('.side_engraving > .selector-wrapper').css('display', 'none');
                                    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${productId.split('-')[1]}"]`).find('.engrave_side_content[data-side="front"]').removeClass('hidden');
                                    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${productId.split('-')[1]}"]`).find('.engrave_side_content[data-side="back"]').addClass('hidden');
                                } else if (jQuery(this).val() == 'Back Side') {
                                    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv[data-product-id='${productId.split('-')[1]}']`).attr('data-side-engraving', 'back');
                                    jQuery(this).parents('.selector-wrapper').find('.side_engraving > .front_side_engraving').css('display', 'none');
                                    jQuery(this).parents('.selector-wrapper').find('.side_engraving > .back_side_engraving').css('display', 'block');
                                    jQuery(this).parents('.selector-wrapper').find('.side_engraving > .selector-wrapper').css('display', 'none');
                                    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${productId.split('-')[1]}"]`).find('.engrave_side_content[data-side="front"]').addClass('hidden');
                                    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${productId.split('-')[1]}"]`).find('.engrave_side_content[data-side="back"]').removeClass('hidden');
                                } else if (jQuery(this).val() == 'Double Sided') {
                                    jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv[data-product-id='${productId.split('-')[1]}']`).attr('data-side-engraving', 'double');
                                    jQuery(this).parents('.selector-wrapper').find('.side_engraving > .selector-wrapper').css('display', 'block');
                                    jQuery(this).parents('.selector-wrapper').find('.side_engraving > .selector-wrapper .side_engraving_input > label').click();
                                    jQuery(this).parents('.selector-wrapper').find('.side_engraving > .selector-wrapper .side_engraving_input > label:first').click();
                                    let frontBackContainerValue = jQuery(this).parents('.selector-wrapper').find('.side_engraving > .selector-wrapper .single-option-selector_engraving[name="SideSwip-' + productId.split('-')[1] + '"]:checked').val();
                                    if (frontBackContainerValue == 'back') {
                                        jQuery(this).parents('.selector-wrapper').find('.side_engraving > .front_side_engraving').css('display', 'none');
                                        jQuery(this).parents('.selector-wrapper').find('.side_engraving > .back_side_engraving').css('display', 'block');
                                        jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${productId.split('-')[1]}"]`).find('.engrave_side_content[data-side="front"]').addClass('hidden');
                                        jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${productId.split('-')[1]}"]`).find('.engrave_side_content[data-side="back"]').removeClass('hidden');
                                    }
                                }
                            } else {

                                jQuery(this).parents('.product-tooltip.multiVariantToolTip[data-engraving="true"][data-product-id="' + productId.split('-')[1] + '"]').removeClass('show');
                                jQuery(this).parents('.product-info').find(`.add-chain.btn._visual_charms_[data-selected-pid="${productId.split('-')[1]}"]`).css('display', 'block');
                                jQuery(this).parents('.product-info').find(`.engraving_LastBtn.engraving_toolBtn[data-product-id="${productId.split('-')[1]}"]`).css('display', 'none');
                                jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv[data-product-id='${productId.split('-')[1]}']`).removeClass('show');
                                jQuery(this).parents('.selector-wrapper').find('.side_engraving').css('display', 'none');
                            }
                        }
                        jQuery("select#" + productId + " option").prop("selected", false);
                        jQuery("select#" + productId + " option[data-variant-slug='" + value + "']").prop("selected", true);
                        jQuery("select#" + productId).trigger('change');
                        jQuery(this).parents('.product-info').find('span.ProductItem__Price'), jQuery("select#" + productId + " option[data-variant-slug='" + value + "']").attr('data-variant-price');
                        jQuery(this).parents('.product-info').find('span.ProductItem__Price').text(jQuery("select#" + productId + " option[data-variant-slug='" + value + "']").attr('data-variant-price'));
                    });

                    jQuery('.single-option-selector_engraving').on('change', function() {
                        let dataProductId = jQuery(this).attr('data-product-id');
                        if (jQuery(this).attr('name') == `SideSwip-${dataProductId}`) {
                            if (jQuery(this).val() == 'front') {
                                jQuery(this).parents('.side_engraving').find('.front_side_engraving').css('display', 'block');
                                jQuery(this).parents('.side_engraving').find('.back_side_engraving').css('display', 'none');
                                jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${dataProductId}"]`).find('.engrave_side_content[data-side="front"]').removeClass('hidden');
                                jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${dataProductId}"]`).find('.engrave_side_content[data-side="back"]').addClass('hidden');
                            } else {
                                jQuery(this).parents('.side_engraving').find('.front_side_engraving').css('display', 'none');
                                jQuery(this).parents('.side_engraving').find('.back_side_engraving').css('display', 'block');
                                jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${dataProductId}"]`).find('.engrave_side_content[data-side="front"]').addClass('hidden');
                                jQuery(`.engraving_contwerakfjsadlkfjwoeifjsmdnv.show[data-product-id="${dataProductId}"]`).find('.engrave_side_content[data-side="back"]').removeClass('hidden');
                            }
                        }
                        if (jQuery(this).attr('name') == `Front_Engrave-${dataProductId}`) {
                            if (jQuery(this).val() == 'Front_Text') {
                                jQuery(this).parents('.front_side_engraving[data-side="front"][data-product-id="' + dataProductId + '"]').find('.lmxcnweirusdkjf[data-option="Front_Text"]').removeClass('hidden');
                                jQuery(this).parents('.front_side_engraving[data-side="front"][data-product-id="' + dataProductId + '"]').find('.lmxcnweirusdkjf[data-option="Front_Monogram"]').addClass('hidden');
                                jQuery(`.engrave_Front_Text[data-product-id="${dataProductId}"]`).css('display', 'block');
                                jQuery(`.engrave_Front_Text[data-product-id="${dataProductId}"]`).attr('data-selected', true);
                                jQuery(`.engrave_Front_Monogram[data-product-id="${dataProductId}"]`).css('display', 'none');
                                jQuery(`.engrave_Front_Monogram[data-product-id="${dataProductId}"]`).attr('data-selected', false);
                            } else {
                                jQuery(this).parents('.front_side_engraving[data-side="front"][data-product-id="' + dataProductId + '"]').find('.lmxcnweirusdkjf[data-option="Front_Text"]').addClass('hidden');
                                jQuery(this).parents('.front_side_engraving[data-side="front"][data-product-id="' + dataProductId + '"]').find('.lmxcnweirusdkjf[data-option="Front_Monogram"]').removeClass('hidden');
                                jQuery(`.engrave_Front_Text[data-product-id="${dataProductId}"]`).css('display', 'none');
                                jQuery(`.engrave_Front_Text[data-product-id="${dataProductId}"]`).attr('data-selected', false);
                                jQuery(`.engrave_Front_Monogram[data-product-id="${dataProductId}"]`).css('display', 'block');
                                jQuery(`.engrave_Front_Monogram[data-product-id="${dataProductId}"]`).attr('data-selected', true);
                            }
                        }
                        if (jQuery(this).attr('name') == `Back_Engrave-${dataProductId}`) {
                            if (jQuery(this).val() == 'Back_Text') {
                                jQuery(this).parents('.back_side_engraving[data-side="back"][data-product-id="' + dataProductId + '"]').find('.lmxcnweirusdkjf[data-option="Back_Text"]').removeClass('hidden');
                                jQuery(this).parents('.back_side_engraving[data-side="back"][data-product-id="' + dataProductId + '"]').find('.lmxcnweirusdkjf[data-option="Back_Monogram"]').addClass('hidden');
                                jQuery(`.engrave_Back_Text[data-product-id="${dataProductId}"]`).css('display', 'block');
                                jQuery(`.engrave_Back_Text[data-product-id="${dataProductId}"]`).attr('data-selected', true);
                                jQuery(`.engrave_Back_Monogram[data-product-id="${dataProductId}"]`).css('display', 'none');
                                jQuery(`.engrave_Back_Monogram[data-product-id="${dataProductId}"]`).attr('data-selected', false);
                            } else {
                                jQuery(this).parents('.back_side_engraving[data-side="back"][data-product-id="' + dataProductId + '"]').find('.lmxcnweirusdkjf[data-option="Back_Text"]').addClass('hidden');
                                jQuery(this).parents('.back_side_engraving[data-side="back"][data-product-id="' + dataProductId + '"]').find('.lmxcnweirusdkjf[data-option="Back_Monogram"]').removeClass('hidden');
                                jQuery(`.engrave_Back_Text[data-product-id="${dataProductId}"]`).css('display', 'none');
                                jQuery(`.engrave_Back_Text[data-product-id="${dataProductId}"]`).attr('data-selected', false);
                                jQuery(`.engrave_Back_Monogram[data-product-id="${dataProductId}"]`).css('display', 'block');
                                jQuery(`.engrave_Back_Monogram[data-product-id="${dataProductId}"]`).attr('data-selected', true);
                            }
                        }
                        if (jQuery(this).attr('name') == `Front_Text-${dataProductId}`) {
                            let data_index = parseInt(jQuery(this).attr('data-count'));
                            let data_engrave_display_set = document.querySelectorAll(`.engrave_Front_Text[data-product-id="${dataProductId}"] span`);
                            for (let i = 0; i <= 2; i++) {
                                if (i <= data_index) {
                                    jQuery(this).parents('.selector-wrapper[data-text="Front_Text"]').find(`.text_line_number input:nth-child(${i + 1})`).css('display', 'block');
                                    data_engrave_display_set[i].style.display = 'block';
                                } else {
                                    jQuery(this).parents('.selector-wrapper[data-text="Front_Text"]').find(`.text_line_number input:nth-child(${i + 1})`).css('display', 'none');
                                    data_engrave_display_set[i].style.display = 'none';
                                }
                            }
                        }
                        if (jQuery(this).attr('name') == `Back_Text-${dataProductId}`) {
                            let data_index = parseInt(jQuery(this).attr('data-count'));
                            let data_engrave_display_set = document.querySelectorAll(`.engrave_Back_Text[data-product-id="${dataProductId}"] span`);
                            for (let i = 0; i <= 2; i++) {
                                if (i <= data_index) {
                                    jQuery(this).parents('.selector-wrapper[data-text="Back_Text"]').find(`.text_line_number input:nth-child(${i + 1})`).css('display', 'block');
                                    data_engrave_display_set[i].style.display = 'block';
                                } else {
                                    jQuery(this).parents('.selector-wrapper[data-text="Back_Text"]').find(`.text_line_number input:nth-child(${i + 1})`).css('display', 'none');
                                    data_engrave_display_set[i].style.display = 'none';
                                }
                            }
                        }
                    });

                    jQuery(document).on('click', '._visual_charms_', function(event, customData) {
                                let save_my_design = document.querySelector('.save_current_builder');
                                save_my_design.classList.remove('hidden');
                                let selectedChainid = ChaimMainCOwekldjf.getAttribute('data-product-id')
                                let dragImageSrc = jQuery(this).attr('data-drag-able-image');
                                if (!document.querySelector('._visual_charms_chain_added')) {
                                    document.querySelector('.charm_builder .toolTipdragandDrop').classList.add('show')
                                    document.querySelector('.sdfsdfdsfeswewr').classList.add('animate_scale')
                                }
                                document.querySelector('.sdfsdfdsfeswewr').style.opacity = '1'
                                var product_id = jQuery(this).attr('data-selected-pid');
                                if (jQuery(this).html().indexOf('span') >= 1) {
                                    jQuery(this).attr('n_o_t_added', parseInt(jQuery(this).attr('n_o_t_added')) + 1);
                                    jQuery(this).html(jQuery(this).attr('n_o_t_added') + ' <span>&#10003;</span>');
                                    jQuery(`.overSelectLabel[data-product-id="${product_id}"]`).html(jQuery(this).attr('n_o_t_added') + ' <span>&#10003;</span>');
                                    jQuery(`.overSelectLabel[data-product-id="${product_id}"]`).attr('n_o_t_added', parseInt(jQuery(this).attr('n_o_t_added')) + 1);
                                } else {
                                    if(jQuery(this).hasClass("singleVariant")){
                                        jQuery(this).html('<span>&#10003;</span>');
                                    } else {
                                        jQuery(this).text('Charm Added');
                                    }
                                    jQuery(this).addClass('_visual_charms_chain_added');
                                    jQuery(`.overSelectLabel[data-product-id="${product_id}"]`).html('<span>&#10003;</span>');
                                }
                                if (!jQuery(this).hasClass("singleVariant")) {
                                    jQuery(this).parents('.product-tooltip').css('transform', 'translateX(100%)');
                                    jQuery(`.overSelectLabel[data-product-id="${product_id}"]`).addClass('_visual_charms_chain_added');
                                }
                                let cartcharmItem = document.querySelector('.charmElement');

                                var selected_variant_id = jQuery('#id-' + product_id).val();
                                var variant_src = null;
                                if (dragImageSrc == 'false') {
                                    for (var v_id in charmsData[product_id].variants) {
                                        var variant = charmsData[product_id].variants[v_id];
                                        if (v_id == selected_variant_id) {
                                            let dataVariantFilesTool = document.querySelector(`option[value='${selected_variant_id}']`).getAttribute('data-variant-files');
                                            if (dataVariantFilesTool == 'false' && variant.featured_image) {
                                                variant_src = variant.featured_image.src;
                                            } else {
                                                variant_src = dataVariantFilesTool;
                                            }
                                        }
                                    }

                                    if (variant_src === null) {
                                        variant_src = charmsData[product_id].images[charmsData[product_id].images.length - 1];
                                    }
                                } else {
                                    variant_src = dragImageSrc;
                                    if (customData) {
                                        if (customData['Front_Image']) {
                                            variant_src = jQuery(this).attr('data-front-side-image');
                                        }
                                    }
                                }
                                let engraving_product = jQuery(this).attr('data-template-engraving');
                                let charmPrice = jQuery(this).parents('.product-info').find('select.variant-select option:checked').attr('data-variant-price')
                                let charmPriceDecimal = jQuery(this).parents('.product-info').find('select.variant-select option:checked').attr('data-variant-price-decimal') / 100
                                let varaint_id = jQuery(this).parents('.product-info').find('select.variant-select option:checked').value
                                let quantity = 1
                                let engrave_type;
                                if (customData && customData[`Back_Engrave`] && customData[`Front_Engrave`]) {
                                    engrave_type = 'Engraving : Double Sided';
                                } else if (customData && customData[`Front_Engrave`]) {
                                    engrave_type = 'Engraving : Front Side';
                                } else if (customData && customData[`Back_Engrave`]) {
                                    engrave_type = 'Engraving : Back Side';
                                }
                                if (jQuery(this).attr('n_o_t_added') > 1) {
                                    if (jQuery(`.productCartContainerGrid[data-variant-id="${selected_variant_id}"]`).length) {
                                        jQuery(`.productCartContainerGrid[data-variant-id="${selected_variant_id}"]`).attr('data-quantity', (1 + parseInt(jQuery(`.productCartContainerGrid[data-variant-id="${selected_variant_id}"]`).attr('data-quantity'))))
                                        jQuery(`.productCartContainerGrid[data-variant-id="${selected_variant_id}"]`).attr('data-price', charmPriceDecimal * parseFloat(jQuery(`.productCartContainerGrid[data-variant-id="${selected_variant_id}"]`).attr('data-quantity')))
                                        jQuery(`.productCartContainerGrid[data-variant-id="${selected_variant_id}"] .quantitydskfj`).text(`${parseInt(jQuery(`.productCartContainerGrid[data-variant-id="${selected_variant_id}"]`).attr('data-quantity'))}`);
                    jQuery(`.productCartContainerGrid[data-variant-id="${selected_variant_id}"] .price`).text('$' + charmPriceDecimal * parseFloat(jQuery(`.productCartContainerGrid[data-variant-id="${selected_variant_id}"]`).attr('data-quantity')));
                } else {
                    cartcharmItem.insertAdjacentHTML('beforeend', `
                        <div class="productCartContainerGrid" data-product-id="${product_id}" data-variant-id="${selected_variant_id}" data-quantity="${quantity}" data-price="${charmPriceDecimal}">
                            <img src="${variant_src}" alt="" width="80px" height="80px">
                            <a class="Heading u-h6 title_variant">${charmsData[product_id].title}${customData ? '<span>' + engrave_type + '</span>' : ''}</a>
                            <a class="Heading u-h6 centerAlign quantitydskfj">${quantity}</a>
                            <a class="Heading u-h6 rightAlign price">${charmPrice}</a>
                        </div>
                    `)
                }
            } else {
                cartcharmItem.insertAdjacentHTML('beforeend', `
                    <div class="productCartContainerGrid" data-product-id="${product_id}" data-variant-id="${selected_variant_id}" data-quantity="${quantity}" data-price="${charmPriceDecimal}">
                        <img src="${variant_src}" alt="" width="80px" height="80px">
                        <a class="Heading u-h6 title_variant">${charmsData[product_id].title}${customData ? '<span>' + engrave_type + '</span>' : ''}</a>
                        <a class="Heading u-h6 centerAlign quantitydskfj">${quantity}</a>
                        <a class="Heading u-h6 rightAlign price">${charmPrice}</a>
                    </div>
                `)
            }
            let top, left;
            let charmWidth = parseFloat(jQuery(this).attr('data-charm-width'));
            let reducedWidth
            if (jQuery(window).width() > 900) {
                reducedWidth = charmWidth * 0.75; // 75% of the original width
                top = 235
                left = 240
            } else {
                reducedWidth = charmWidth * 0.50; // 75% of the original width
                top = 100
                left = 120
            }
            var HTML = '\
                <div' + (customData ? ' data-engraving="true"' : '') + ' style="position: absolute;top:'+ top + 'px;left: ' + left + 'px;display: block;" data-index="' + preload_entities['number_of_charms'] + '" onclick="CancelPopup()" class="charm_w draggable draggable_' + charmsData[product_id].handle + '" data-product-variant-id="' + selected_variant_id + '" data-product-id="' + product_id + '" >\
                    ' + (customData && customData[`Back_Image`] ? '<div class="data_engraving_sides" onclick="RotateSide(this,`'+ variant_src + '`,`' + jQuery(this).attr('data-back-side-image') + '`)"><img width="15" height="auto" src="https://cdn.shopify.com/s/files/1/1988/2711/files/noun-rotate-5824289_7fb74f59-8302-4ab4-af7d-319adb56a54a.png?v=1744796974"></div>' : '' ) + '\
                    <img src="'+ variant_src + '"' + (engraving_product == 'true' ? ' class="egraving_product_image" width="'+ reducedWidth +'" height="auto"' : '') + '>\
                    <div class="charm-rotate_l 1">\
                        <img src="//cdn.shopify.com/s/files/1/1988/2711/files/Left_arrow.png?v=1732236118">\
                    </div>\
                    <div class="charm-close 1" data-index="1" data-pid="" data-vid="' + product_id + '">\
                    <img src="//cdn.shopify.com/s/files/1/1988/2711/files/Cross_01.png?v=1732236118" />\
                    </div>\
                    <div class="charm-rotate_r 1">\
                        <img src="//cdn.shopify.com/s/files/1/1988/2711/files/Left_arrow.png?v=1732236118">\
                    </div>\
                    ' + (customData ? '<div class="data_engraving_properties" style="display: none;">' + JSON.stringify(customData) + '</div>' : '' ) + '\
                </div>\
            ';
            jQuery('.charm-container').append(HTML);

            jQuery(".draggable_" + charmsData[product_id].handle).draggable({
                containment: ".charm_builder",
                scroll: true,
                cursor: "move",
                refreshPositions: true,
                stop: function (event, ui) {
                    let top = ui.position.top;
                    let left = ui.position.left;

                    let index = jQuery(this).data("index");
                    if (preload_entities.charms[parseInt(index) + 1]) {
                        preload_entities.charms[parseInt(index) + 1].top = `${top}px`;
                        preload_entities.charms[parseInt(index) + 1].left = `${left}px`;
                    }

                    let reindexedCharms = Object.values(preload_entities.charms).reduce((acc, charm, i) => {
                        acc[i + 1] = charm;
                        return acc;
                    }, {});

                    // (Optional) Update URL or save changes
                    let queryString = new URLSearchParams({
                        chain: JSON.stringify(preload_entities.chain),
                        screen_size: JSON.stringify(preload_entities.screen_size),
                        number_of_charms: JSON.stringify(preload_entities.number_of_charms),
                        charms: JSON.stringify(reindexedCharms)
                    }).toString();

                    let newUrl = `${window.location.pathname}?${queryString}`;
                    window.history.pushState({}, "", newUrl);
                    localStorage.setItem("queryString", JSON.stringify(queryString));
                    localStorage.setItem("last_updated", new Date().toISOString());
                }
            });
            if(chainConditions[selectedChainid]){
                let curentCharmNumber = document.querySelectorAll('.charm_w.draggable');
                if (curentCharmNumber.length >= chainConditions[selectedChainid].limit) {
                    ChaimMainCOwekldjf.classList.add('overlay')
                    document.querySelector('.chainnameandlimit').innerHTML = chainConditions[selectedChainid].content +  '<span style="font-family:Berlingske Serif Bold !important;">0' + chainConditions[selectedChainid].limit + '</span>';
                    document.querySelector('.toolTipdragandDropasdfkjdsfk').classList.add('show');
                };
            };
            CharmPreloadEntires();
        });
        function CharmPreloadEntires() {
            let current_selected_charms = document.querySelectorAll('.charm-container > div.charm_w');
            let charms_object = {};
            current_selected_charms.forEach(charm => {
                charms_object = {
                    ...charms_object,
                    [parseInt(charm.getAttribute('data-index')) + 1]: {
                        id: charm.getAttribute('data-product-id'),
                        variant: charm.getAttribute('data-product-variant-id'),
                        top: charm.style.top,
                        left: charm.style.left,
                        transform: charm.style.transform ? charm.style.transform : 'none', 
                    }
                }
            })
            preload_entities['charms'] = charms_object;
            preload_entities['number_of_charms'] = current_selected_charms.length;
            let reindexedCharms = Object.values(preload_entities.charms).reduce((acc, charm, i) => {
                acc[i + 1] = charm;
                return acc;
            }, {});
            // Convert full object into query string
            let queryString = new URLSearchParams({
                chain: JSON.stringify(preload_entities.chain),
                screen_size: JSON.stringify(preload_entities.screen_size),
                number_of_charms: JSON.stringify(preload_entities.number_of_charms),
                charms: JSON.stringify(reindexedCharms)
            }).toString();
            let newChainUrl = `${window.location.pathname}?${queryString}`;
            window.history.pushState({}, "", newChainUrl);
            localStorage.setItem("queryString", JSON.stringify(queryString));
            localStorage.setItem("last_updated", new Date().toISOString());
        }

        jQuery(document).on('click', '._neclace_br_', function (event) {
            var product_id = jQuery(this).attr('data-selected-pid');
            let dragImageSrc = jQuery(this).attr('data-drag-able-image');
            ChaimMainCOwekldjf.setAttribute('data-product-id', product_id)
            if(document.querySelectorAll('.charm-close')){
                document.querySelectorAll('.charm-close').forEach(close => {
                    close.click();
                })
            }
            jQuery('._neclace_br_').text('Select Chain');
            jQuery(this).text('Chain Added');
            jQuery('._neclace_br_').removeClass('_neclace_br_chain_added');
            jQuery(this).addClass('_neclace_br_chain_added');
            jQuery('.overSelectLabel[data-select-type="chain"]').text('+Add');
            jQuery(`.overSelectLabel[data-product-id="${product_id}"]`).html('<span>&#10003;</span>');
            jQuery('.overSelectLabel[data-select-type="chain"]').removeClass('_neclace_br_chain_added');
            jQuery(`.overSelectLabel[data-product-id="${product_id}"]`).addClass('_neclace_br_chain_added');
            if (!jQuery(this).hasClass("singleVariant")) {
                if (jQuery('.chainSizing').hasClass('show')) {
                    jQuery('.chainSizing').removeClass('show')
                }
                jQuery(this).parents('.product-tooltip').css('transform', 'translateX(100%)');
            }
            let cartChainItem = document.querySelector('.chainElement .productCartContainerGrid');
            let chainName = jQuery(this).parents('.product-info').find('.step_heading').text()
            let chainPrice = jQuery(this).parents('.product-info').find('select option:checked').attr('data-variant-price')
            let chainPricedecimal = jQuery(this).parents('.product-info').find('select option:checked').attr('data-variant-price-decimal') / 100
            var selected_variant_id = jQuery('#id-' + product_id).val();
            cartChainItem.setAttribute('data-price', chainPricedecimal)

            if (typeof (window.jQuery.ui) == 'undefined') {
                var head = document.getElementsByTagName('head')[0];
                var script__1 = document.createElement('script');
                script__1.type = 'text/javascript';
                script__1.src = 'https://code.jquery.com/jquery-1.12.4.js';
                var script__2 = document.createElement('script');
                script__2.type = 'text/javascript';
                script__2.src = 'https://code.jquery.com/ui/1.12.1/jquery-ui.js';
                var script__3 = document.createElement('script');
                script__3.type = 'text/javascript';
                script__3.src = "https://cdnjs.cloudflare.com/ajax/libs/jqueryui-touch-punch/0.2.3/jquery.ui.touch-punch.min.js";
                head.appendChild(script__1);
                head.appendChild(script__2);
                head.appendChild(script__3);
            }
            // jQuery(".draggable").draggable("destroy");
            // jQuery('.draggable').remove();


            var variant_src = null;
            if (dragImageSrc == 'false') {
                for (var v_id in chainsData[product_id].variants) {
                    var variant = chainsData[product_id].variants[v_id];
                    if (v_id == selected_variant_id && variant.featured_image) {
                        variant_src = variant.featured_image.src;
                    }
                }
                if (variant_src === null) {
                    variant_src = chainsData[product_id].images[chainsData[product_id].images.length - 1];
                }
            } else {
                variant_src = dragImageSrc;
            }
            jQuery('#image_visual video.main-image').remove();
            jQuery('#image_visual img.main-image').attr('src', variant_src).attr('data-selected-product-id', selected_variant_id);
            jQuery('#image_visual img.main-image').css('display', 'block');
            cartChainItem.innerHTML = `
                <img src="${variant_src}" alt="" width="80px" height="80px">
                <a class="Heading u-h6">${chainName}</a>
                <a class="Heading u-h6 centerAlign">1</a>
                <a class="Heading u-h6 rightAlign">${chainPrice}</a>
            `
            CharmSlide();
            preload_entities['chain'] = {
                id: product_id,
                variant: selected_variant_id
            }
            let queryString = new URLSearchParams({
                chain: JSON.stringify(preload_entities.chain),
                screen_size: JSON.stringify(preload_entities.screen_size)
            }).toString();
            let newChainUrl = `${window.location.pathname}?${queryString}`;
            window.history.pushState({}, "", newChainUrl);
            localStorage.setItem("queryString", JSON.stringify(queryString));
            localStorage.setItem("last_updated", new Date().toISOString());
        });

        jQuery(document).on('click', '.charm-rotate_l', function (event) {
            let rl = getRotationDegrees(jQuery(this).parents('.charm_w')) - 10;
            rotate($(this).parents('.charm_w'), rl);
        });

        jQuery(document).on('click', '.charm-rotate_r', function (event) {
            let rr = getRotationDegrees(jQuery(this).parents('.charm_w')) + 10;
            rotate(jQuery(this).parents('.charm_w'), rr);
        });
        
        jQuery(document).on('click', '.charm-close', function (event) {
            jQuery(this).parents('.charm_w').remove();
            let index = jQuery(this).parents('.charm_w').attr('data-index')
            let pId = jQuery(this).parents('.charm_w').attr('data-product-id')
            let vId = jQuery(this).parents('.charm_w').attr('data-product-variant-id')
            let charmBtn = document.querySelectorAll(`._visual_charms_chain_added[data-product-id="${pId}"]`);
            let quantityIndex = parseInt(jQuery(`.productCartContainerGrid[data-variant-id="${vId}"]`).attr('data-quantity'));
            if(quantityIndex == 1){
                jQuery(`.productCartContainerGrid[data-variant-id="${vId}"]`).remove();
            } else {
                let singlePrice = parseInt(jQuery(`.productCartContainerGrid[data-variant-id="${vId}"]`).attr('data-price')) / quantityIndex;
                quantityIndex = quantityIndex - 1;
                let totalValue = singlePrice * quantityIndex
                jQuery(`.productCartContainerGrid[data-variant-id="${vId}"]`).attr('data-quantity', quantityIndex);
                jQuery(`.productCartContainerGrid[data-variant-id="${vId}"]`).attr('data-price', totalValue);
                jQuery(`.productCartContainerGrid[data-variant-id="${vId}"] .price`).text('$' + totalValue);
                jQuery(`.productCartContainerGrid[data-variant-id="${vId}"] .quantitydskfj`).text(quantityIndex);
            }
            for (let index = 0; index < charmBtn.length; index++) {
                if (charmBtn[index].getAttribute('n_o_t_added') == 1) {
                    charmBtn[index].classList.remove('_visual_charms_chain_added');
                    charmBtn[index].innerHTML = '+Add';
                } else {
                    let currentIndex = charmBtn[index].getAttribute('n_o_t_added');
                    charmBtn[index].setAttribute('n_o_t_added', parseInt(currentIndex) - 1);
                    if (parseInt(currentIndex) - 1 == 1) {
                    charmBtn[index].innerHTML = `<span>&#10003;</span>`;
                    } else {
                    charmBtn[index].innerHTML = `${parseInt(currentIndex) - 1} <span>&#10003;</span>`;
                    }
                };
            }
            
            let currentChainIdcosdflkj = ChaimMainCOwekldjf.getAttribute('data-product-id')
            if(chainConditions[currentChainIdcosdflkj]){
                let curentCharmNumber = document.querySelectorAll('.charm_w.draggable');
                if (curentCharmNumber.length >= chainConditions[currentChainIdcosdflkj].limit) {
                    ChaimMainCOwekldjf.classList.add('overlay');
                    document.querySelector('.chainnameandlimit').innerHTML = chainConditions[currentChainIdcosdflkj].content +  '<span style="font-family:Berlingske Serif Bold !important;">0' + chainConditions[currentChainIdcosdflkj].limit + '</span>';
                    document.querySelector('.toolTipdragandDropasdfkjdsfk').classList.add('show');
                } else {
                    ChaimMainCOwekldjf.classList.remove('overlay');
                    document.querySelector('.toolTipdragandDropasdfkjdsfk').classList.remove('show');
                }
            };

            delete preload_entities.charms[parseInt(index) + 1];
            // Reindex charms to have sequential numeric keys
            let reindexedCharms = Object.values(preload_entities.charms).reduce((acc, charm, i) => {
                acc[i + 1] = charm;
                return acc;
            }, {});
            preload_entities.number_of_charms = Object.keys(preload_entities.charms).length;
            let queryString = new URLSearchParams({
                chain: JSON.stringify(preload_entities.chain),
                screen_size: JSON.stringify(preload_entities.screen_size),
                number_of_charms: JSON.stringify(preload_entities.number_of_charms),
                charms: JSON.stringify(reindexedCharms)
            }).toString();
            let newChainUrl = `${window.location.pathname}?${queryString}`;
            window.history.pushState({}, "", newChainUrl);
            localStorage.setItem("queryString", JSON.stringify(queryString));
            localStorage.setItem("last_updated", new Date().toISOString());
        });

        $('#addItemsToCart').on('click', function (event) {
            event.preventDefault();
            document.querySelector('.loading_screen').style.display = 'flex';
            document.querySelector('.loading_screen').style.justifyContent = 'center';
            document.querySelector('.loading_screen').style.alignItems = 'center';
            document.querySelector('.loading_screen').style.flexDirection = 'column';
            document.querySelector('.loading_screen').style.gap = '0';
            document.querySelector('.loading_screen .main_loading_grid_container').style.display = 'none';
            document.querySelector('.loading_screen .add_to_cart_text').style.display = 'block';
            document.querySelector('.loading_screen .loading_gif').style.display = 'flex';
            jQuery('.toolTipdragandDrop').remove();
            jQuery('.toolTipdragandDropasdfkjdsfk').remove();
            getStyleSheet();
            $('link[rel=stylesheet][href*="static.klaviyo.com"]').remove();
            $('link[rel=stylesheet][href*="productreviews.shopifycdn.com"]').remove();
            var loading_image = '<img src="//cdn.shopify.com/s/files/1/1988/2711/files/circle_loading.gif?v=1619730563" style="width: 46px;height:auto;position: absolute;">';
            $('#addItemsToCart span').css('visibility', 'hidden');
            $('#addItemsToCart').append(loading_image);

            var node = document.querySelector('#image_visual #charm_visual');     
            waitForNodeReady(node).then(function () {
                return domtoimage.toPng(node); // warm-up pass, same size, result discarded
            }).then(function () {
                return domtoimage.toPng(node); // real pass
            }).then(function (dataUrl) {
                postCharmsImg(dataUrl);
            }).catch(function (e) {
                console.log(e);
            });

            // domtoimage.toPng(node,
            //     {
            //         width: 100,
            //         height: 100
            //     })
            //     .then(function (dataUrl) {
            //         domtoimage.toPng(node)
            //             .then(function (dataUrl) {
            //                 var img = new Image();
            //                 img.src = dataUrl;
            //                 var img_src = img.src;
            //                 postCharmsImg(dataUrl);
            //             });
            //     }).catch(e => {
            //         console.log(e);
            //     });


            Shopify.moveAlong = function () {
                // If we still have requests in the queue, let's process the next one.
                Shopify.queue = [];
                var $this = $(this);
                var properties = {};
                if (jQuery('#custom_charm_image').val() != '') {
                    properties['_custom_image_visual_exist'] = 'yes'
                    properties['_custom_image_notes'] = jQuery('#notes_for_custom_necklace').val();
                    properties['_custom_image_message'] = jQuery('#message_for_custom_necklace').val();
                    properties['_custom_image_visual'] = jQuery('#custom_charm_image').val();
                    properties['_custom_image_visual_id'] = jQuery('#custom_charm_image_id').val();

                }

                if (jQuery('#charm_visual img.main-image').attr('data-selected-product-id') != "") {
                    Shopify.queue.push({
                        id: jQuery('#charm_visual img.main-image').attr('data-selected-product-id'),
                        quantity: 1,
                        properties: properties
                    });
                }



                jQuery('#charm_visual .charm_w').each(function (index) {
                    if (jQuery(this).attr('data-product-variant-id') != "") {
                        let newProperties = properties
                        if (jQuery(this).attr('data-engraving') == 'true') {
                        let newObject = JSON.parse($(this).find('.data_engraving_properties').html());
                        newProperties = {...newObject, ...properties}
                        }
                        Shopify.queue.push({
                            id: jQuery(this).attr('data-product-variant-id'),
                            quantity: 1,
                            properties: newProperties
                        });
                    }
                });

                if (Shopify.queue.length) {
                    var data = {
                        items: Shopify.queue,
                    };
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        dataType: 'json',
                        async: false,
                        data: data,
                        success: function (res) {
                            window.location.href = '/cart';
                        },
                        error: function () {
                            window.location.href = '/cart';
                        }
                    });
                }
                // If the queue is empty, we will redirect to cart
                else {
                    window.location.href = '/cart';
                }
            };

        });
    }
    script__2.src = 'https://code.jquery.com/ui/1.12.1/jquery-ui.js';
    head.appendChild(script__1);
    head.appendChild(script__2);
    head.appendChild(script__3);
});